/**
 * Whether or not this is a dev environment e.g. localhost
 */
export const IS_DEV_ENV = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

/**
 * Whether or not this is a test environment i.e. unit tests, integration tests or UI tests are running.
 */
export const IS_TEST_ENV = (!process.env.NODE_ENV || process.env.NODE_ENV === 'test');


export const API_BASE_URL = IS_DEV_ENV ? `https://dev.resorttools.ikonpass.com/api` : window.location.origin + '/api'
export const CONFIG_BASE_URL = IS_DEV_ENV ? 'https://dev.resorttools.ikonpass.com/configapi' : window.location.origin + '/configapi'
export const Users_BASE_URL = IS_DEV_ENV ? 'https://dev.resorttools.ikonpass.com/userapi' : window.location.origin + '/userapi'

export const clientIds = {
  dev: 'C68BZa8vS19Or0qZg80LCs1cArUSvxl7',
  qa: 'AFeUSA8Ymj3i2uvZZE17MRf098I6WKBK',
  uat: 'XoXKJvdhaUWoZRDFNFlwfYqq04dvrKne',
  prod: 'ULZMzxWIheXePAsyBxTUr6QKe8lMmsTb'
}
